import graphql__34e98c4e2f3fe64a6581 from "./__generated__/ContributionsMapContributionsMarkers_map.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import useFilterableContributionsList from "../useFilterableContributionsList";
import { ContributionsMapContributionsMarkersFragment_participativeModule } from "./ContributionsMapContributionsMarkersFragment";
import ContributionsMapThemeContributionsMarkers from "./ContributionsMapThemeContributionsMarkers";
import { CONTRIBUTIONS_CONNECTION_TYPE_MARKERS } from "../../../../reducers/contributionsConnections";

// For the map markers, we want to display all the contributions at once. The request is
// optimized to load the least possible data, but could be still optimized with server
// side markers clustering to avoid loading each contribution data and cluster them in
// the client.
//
export const CONTRIBUTIONS_BATCH_SIZE = 2147483647;

const ContributionsMapContributionsMarkers = props => {
  const { contributions: contributionMarkers } = useFilterableContributionsList({
    contribuable: props.participativeModule,
    fragment: ContributionsMapContributionsMarkersFragment_participativeModule,
    contributionsBatchSize: CONTRIBUTIONS_BATCH_SIZE,
    // Set the connectionType to markers, to allow recording the marks connection id to
    // be stored as such in the contributions connection ids redux store, and be used to
    // add the new contribution marker to the connection when adding a new contribution
    // is created.
    connectionType: CONTRIBUTIONS_CONNECTION_TYPE_MARKERS,
    // Since the filterable contributions list we use here is not the same than the one in
    // the sidebar contributions list, which is used by the filters loader, if the filter
    // combination was not already loaded in a previous filtering action, we want the
    // fragment to be fetched from a network query, so we force this behavior here.
    fetchPolicy: "store-or-network",
    // Since we're fetching markers from the contributions map visualization and not
    // the contributions directly, we need to provide a custom selector for the
    // contributionsMarkers to be retrieved from the fetched participativeModule response.
    contributionsSelector: participativeModule =>
      participativeModule.visualization.contributionsMarkers
  });

  // The `map` fragment provided data is passed down from the parent components to the
  // actual marker component to avoid shared data from the map (themes and other general
  // data) to be fetched again from the markers query.
  const map = useFragment(ContributionsMapContributionsMarkers_map, props.map);

  const themeScopedContributionMarkers = useMemo(() => {
    return Object.values(
      contributionMarkers.reduce((markersByThemeId, contributionMarker) => {
        const { themeId } = contributionMarker;

        if (!markersByThemeId[themeId])
          markersByThemeId[themeId] = { themeId, contributionMarkers: [] };
        markersByThemeId[themeId].contributionMarkers.push(contributionMarker);

        return markersByThemeId;
      }, {})
    );
  }, [contributionMarkers]);

  return (
    <>
      {themeScopedContributionMarkers.map(({ themeId, contributionMarkers }) => (
        <ContributionsMapThemeContributionsMarkers
          key={themeId}
          contributionMarkers={contributionMarkers}
          map={map}
          themeId={themeId}
        />
      ))}
    </>
  );
};

const ContributionsMapContributionsMarkers_map = graphql__34e98c4e2f3fe64a6581;

export default ContributionsMapContributionsMarkers;
